import { ActionTypes } from "../constantes/ActionTypes";
import axios from "../../../../common/axios";

export const shipmentInfoByUserStart = (action) => {
  return (dispatch) => {
    dispatch(action);
    axios
      .get(
        `/getShipmentsByProfile`
      )
      .then((response) => {
        dispatch(shipmentInfoSuccess(response.data));
      })
      .catch((error) => {
        dispatch(shipmentInfoFailed(error.response?.data));
      });
  };
};

export const shipmentInfoSuccess = (shipmentInfo) => {
  return {
    type: ActionTypes.ACTION_SHIPMENT_BY_USER_SUCCESS,
    payload: shipmentInfo,
  };
};

export const shipmentInfoFailed = (error) => {
  return {
    type: ActionTypes.ACTION_SHIPMENT_BY_USER_FAILED,
    payload: error,
  };
};

export const shipmentInfoInit = () => {
  return {
    type: ActionTypes.ACTION_SHIPMENT_BY_USER_INIT,
    payload: "",
  };
};
